import { render } from "./VirtualLearningEnvironmentView.vue?vue&type=template&id=479625cc&scoped=true"
const script = {}

import "./VirtualLearningEnvironmentView.vue?vue&type=style&index=0&id=479625cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479625cc"]])

export default __exports__